/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { lAC_AssignCartCustomerAsync } from '../custom-actions/DataActionExtension.g';
import { ILAC_AuthToken } from '../custom-actions/DataServiceEntities.g';
import { withFreshToken } from '../utils/authService';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

/**
 * AssignCartCustomer Input Action
 */
export class AssignCartCustomerInput implements Msdyn365.IActionInput {
    public authTokenCookie: ILAC_AuthToken;
    public cartId: string;

    constructor(cartId: string, authTokenCookie: ILAC_AuthToken) {
        this.authTokenCookie = authTokenCookie;
        this.cartId = cartId;
    }

    public getCacheKey = () => `LAC_ASSIGNCARTCUSTOMER_${this.cartId}`;
    public getCacheObjectType = () => 'LAC_ASSIGNCARTCUSTOMER';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

async function assignCartCustomerAsync(input: AssignCartCustomerInput, ctx: Msdyn365.IActionContext): Promise<Entities.Cart | undefined> {
    try {
        const result = await withFreshToken(ctx, input.authTokenCookie, async carried =>
            lAC_AssignCartCustomerAsync({ callerContext: ctx }, carried, input.cartId)
        );
        if (result) {
            return result;
        }
    } catch (error) {
        console.log('Error assigning the cart customer:', error);
        throw error;
    }

    return undefined;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<Entities.Cart | undefined>>assignCartCustomerAsync,
    id: 'LAC_AssignCartCustomer'
});
